import React from "react";
import {
  IonGrid,
  IonItem,
  IonLabel,
  IonRow,
  IonCol
} from "@ionic/react";
export const Posts = (props: {
  listOfPosts: any;
  totPages: number;
  thePage: number;
  handleClickNextPage: any;
}) => {
  return (
    <IonGrid>
      {props.listOfPosts.map(
        (
          post: {
            postsfound: boolean;
           mtitle: { rendered: string };
            excerpt: { rendered: string };
            question: { rendered: string };
            featured_media: any;
            id: number;
            date: any;
          },
          index: string | number | null | undefined
        ) => (
          <IonGrid key={index}>
             {(function() { //check to see if the toggle is applied
                if(post.postsfound === true){//optional rows.
                  console.log('posts found' + index)
                    return(
                      <IonItem href={"/map/" + post.id}>
                        <IonRow class="listitem">
                          <IonCol size='8'> 
                            <IonLabel>{post.mtitle}</IonLabel>
                            {post.date}
                          </IonCol>
                        </IonRow>
                      </IonItem>
                    )
                }else{
                  return(
                    <p>Sorry none found</p>
                  )
                }
            })()}  
              </IonGrid>
            )
          )}

    </IonGrid>
  );
};
